import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import MyDetails from "personalsettings/mydetailspanel/mydetails";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  userToClient: server.dto.UserForInternalAdmin | server.dto.UserForExternalAdmin
  userSmall: server.dto.UserSmall
}

const TransferUserOptionsPanel = (props: Props) => {
  return <>
    <GeneralOptionsPanel
      title={<MyDetails user={props.userSmall} />}
      links={[
        {
          href: props.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }, {
          href: routes.internalUser_Detail(props.userToClient.userToClientId).absolute,
          text: RESX.Buttons.DetailView,
          visible: true,
        }
      ]}
      data={props.optionsPanelData}
    />
  </>;
};

export default TransferUserOptionsPanel;